import { render, staticRenderFns } from "./ContestOfferSummaryBidderDetails.vue?vue&type=template&id=05d25b0a&scoped=true&"
import script from "./ContestOfferSummaryBidderDetails.vue?vue&type=script&lang=js&"
export * from "./ContestOfferSummaryBidderDetails.vue?vue&type=script&lang=js&"
import style0 from "./ContestOfferSummaryBidderDetails.vue?vue&type=style&index=0&id=05d25b0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d25b0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VCardTitle,VDivider,VFlex,VLayout})
